import React, { useEffect, useMemo, useState } from 'react'
import { cookiesTool } from 'react-gdpr'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import GDPRBanner, { GDPRBannerProps } from '../../components/GDPRBanner'
import { actions, selectors } from '../../redux'

const Gdpr = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [isHidden, setIsHidden] = useState(false)
  const [allowRender, setAllowRender] = useState(false)

  const cookiesSettings = useSelector(selectors.app.cookiesSettings)
  const enabled = useSelector(selectors.tracking.enabled)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleOpenSettings() {
    dispatch(actions.app.openCookiesSettings())
  }

  function handleRefuse() {
    cookiesTool.setActive('analytics', false)
    cookiesTool.setActive('cookiesEdited', true)
    setIsHidden(true)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleAccept() {
    cookiesTool.setActive('analytics', true)
    cookiesTool.setActive('cookiesEdited', true)
    setIsHidden(true)
    dispatch(actions.tracking.enableTracking())
  }

  useEffect(() => {
    setAllowRender(true)

    if (cookiesSettings || enabled) {
      setIsHidden(true)
    }
  }, [cookiesSettings, enabled])

  const props: GDPRBannerProps = useMemo(
    () => ({
      title: t('gdpr.banner.title'),
      logo: {
        src: `${import.meta.env.BASE_URL}images/logo.png`,
        alt: t('footer.logo.alt'),
      },
      description: t('gdpr.banner.description'),
      gdprSettings: {
        title: 'Personnaliser mes préférences de cookies',
        onClick: handleOpenSettings,
      },

      buttons: {
        accept: {
          text: t('gdpr.banner.button.accept.text'),
          onClick: handleAccept,
        },
        refuse: {
          text: t('gdpr.banner.button.refuse.text'),
          onClick: handleRefuse,
        },
      },
    }),
    [handleAccept, handleOpenSettings, t]
  )

  if (!allowRender || isHidden || cookiesTool.isActive('cookiesEdited')) {
    return null
  }

  return <GDPRBanner {...props} />
}

export default Gdpr
